import React, { useState } from "react";
import Carousel from "react-bootstrap/Carousel";
import { vibesColors as colors } from "../../theme/vibesColors";

/**
 * Full-width venue banner — slider when multiple images; title row uses same horizontal padding as page body.
 */
export default function ClubHeroBanner({
  imageUrls = [],
  venueName,
  logoUrl,
  topLeftNode = null,
  topRightNode = null,
}) {
  const urls = Array.isArray(imageUrls) ? imageUrls.filter(Boolean) : [];
  const [idx, setIdx] = useState(0);
  const hasSlider = urls.length > 1;

  return (
    <section className="club-hero w-100">
      <div className="club-hero__slider">
        {hasSlider ? (
          <Carousel
            activeIndex={idx}
            onSelect={(i) => setIdx(i)}
            className="club-hero-carousel hero-carousel-frost"
            indicators
            controls
            interval={6000}
            pause="hover"
          >
            {urls.map((url, i) => (
              <Carousel.Item key={`${url}-${i}`}>
                <div className="club-hero__slide">
                  <img
                    src={url}
                    alt=""
                    className="club-hero__img"
                    loading={i === 0 ? "eager" : "lazy"}
                    decoding="async"
                  />
                </div>
              </Carousel.Item>
            ))}
          </Carousel>
        ) : (
          <div className="club-hero__slide">
            {urls[0] ? (
              <img
                src={urls[0]}
                alt=""
                className="club-hero__img"
                loading="eager"
                decoding="async"
              />
            ) : null}
          </div>
        )}
        <div className="club-hero__overlay" aria-hidden />
        {topLeftNode ? <div className="club-hero__top-left">{topLeftNode}</div> : null}
        {topRightNode ? <div className="club-hero__top-right">{topRightNode}</div> : null}
        <div className="club-hero__bar">
          <div className="club-hero__bar-inner">
            <div className="d-flex flex-column flex-sm-row align-items-sm-end gap-3">
              <div
                className="flex-shrink-0 rounded-circle border club-hero__logo"
                style={{
                  width: "clamp(64px, 10vw, 96px)",
                  height: "clamp(64px, 10vw, 96px)",
                  backgroundImage: logoUrl ? `url(${logoUrl})` : undefined,
                  backgroundColor: "#1a0a2e",
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                  borderColor: `${colors.violate}88`,
                  boxShadow: "0 8px 28px rgba(0,0,0,0.45)",
                }}
                role="img"
                aria-label=""
              />
              <div className="pb-sm-1">
                <p
                  className="text-uppercase small mb-1"
                  style={{ color: colors.violate, letterSpacing: "0.08em" }}
                >
                  Venue
                </p>
                <h1
                  className="text-white fw-bold mb-0"
                  style={{
                    fontSize: "clamp(1.5rem, 4vw, 2.35rem)",
                    lineHeight: 1.2,
                    textShadow: "0 2px 24px rgba(0,0,0,0.65)",
                  }}
                >
                  {venueName}
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
